import React from 'react'



function Alert ({msg, show}){
  // const [ show, setShow ] = useState(true)

  // setInterval(()=>{
  //   setShow(!show)
  // },3000)

  return(

    <div className={`alertbox error ${show?'show':''}`}>
      <div className="alert">
        <div className="msg">
          { msg }
        </div>
      </div>
    </div>

  )
}

export default Alert